import React from 'react';

import AddControl from 'components/add_control';
import { ContactFormBusinessInput } from './input';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { FormContact } from 'bundles/backoffice/contacts/forms/types';

interface Props {
  allowSavingPrivateContacts?: boolean;
  contact: FormContact;
  onChange: (attributes: Partial<FormContact>) => void;
}

export default function ContactFormBusinessInputs({
  allowSavingPrivateContacts, contact, onChange
}: Props) {
  const businessRecords = [...contact.businessRecords];

  if (businessRecords.length === 0) {
    businessRecords.push({ business: null, primary: true });
    onChange({ businessRecords });
  }

  function addBusiness() {
    onChange({
      businessRecords: [
        ...contact.businessRecords,
        { business: null, primary: false },
      ]
    });
  }

  function replaceBusiness(business: Contact | null, index: number) {
    const updatedRecords = [...contact.businessRecords];
    updatedRecords[index] = { ...updatedRecords[index], business };
    onChange({ businessRecords: updatedRecords });
  }

  function removeBusiness(index: number) {
    const updatedRecords = [...contact.businessRecords];
    updatedRecords.splice(index, 1);
    onChange({ businessRecords: updatedRecords });
  }

  function setPrimary(index: number) {
    onChange({
      businessRecords: contact.businessRecords.map((record, i) => {
        return {
          ...record,
          primary: i === index
        };
      }),
    });
  }

  function setJobTitle(index: number, jobTitle: string) {
    const updatedRecords = [...contact.businessRecords];
    updatedRecords[index] = { ...updatedRecords[index], jobTitle };
    onChange({ businessRecords: updatedRecords });
  }

  return <>
    {businessRecords.map((businessRecord, i) => (
      <ContactFormBusinessInput
        allowSavingPrivateContacts={allowSavingPrivateContacts}
        businessRecord={businessRecord}
        contact={contact}
        count={businessRecords.length}
        index={i}
        key={i}
        onChange={business => replaceBusiness(business, i)}
        onJobTitleChange={jobTitle => setJobTitle(i, jobTitle)}
        onPrimaryChange={() => setPrimary(i)}
        onRemove={() => removeBusiness(i)}
      />
    ))}

    <AddControl onClick={addBusiness}>
      Add another company
    </AddControl>
  </>;
}
